import { CommonModule } from "@angular/common";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import type { Observable } from "rxjs";
import { DisableLightThemeDirective } from "src/app/core/directive/disable-light-theme.directive";
import { ThemeService } from "src/app/core/service/theme-switcher.service";
import { SvgIconComponent } from "../social-icons/svg-icon/svg-icon.component";

@Component({
  selector: "app-theme-switcher",
  standalone: true,
  imports: [CommonModule, DisableLightThemeDirective, SvgIconComponent],
  templateUrl: "./theme-switcher.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./theme-switcher.component.scss"],
})
export class ThemeSwitcherComponent {
  @Input() public enableLightTheme: boolean = false;
  public isLightTheme$: Observable<boolean> = this._themeService.isLightTheme$;

  constructor(private _themeService: ThemeService) {}

  public toggleTheme(): void {
    this._themeService.toggleTheme();
  }
}
